// extracted by mini-css-extract-plugin
export default {"textHeader":"editableText_textHeader__9DCBz","full_loader":"editableText_full_loader__5akn4"};